const returnManagementErrorMessage = {
  ERR_MULTI_INDENT_PER_TRANSACTION: 'multiple indents per transaction is not allowed',
  ERR_SHIPMENT_NO_NOT_ASSOCIATED: 'shipment number not associated with indent id',
  ERR_INDENT_NOT_FOUND_INVALID_STATUS: 'indent not found / indent not in valid status',
  ERR_DUPLICATE_INPUT_DATA: 'duplicate input data',
  ERR_NO_MATERIALS_FOR_GIVEN_DETAILS: 'no materials found for given details',
  ERR_RETURN_QTY_EXCEEDED: 'return quantity cannot be more than remaining material quantity',
  ERR_SOURCE_DESTINATION_NA_INDENT: 'source destination combination not found in indent',
  ERR_LR_NO_NA_INDENT: 'lr number not found for given source destination combination',
  ERR_RELEASE_TIME_CANNOT_BE_AFTER_REACH_TIME: 'release time should be between reach time and current time',
  ERR_RELEASE_TIME_CANNOT_BE_FUTURE_TIME: 'release time cannot be future time',
  ERR_RETURN_CREATION_WINDOW_EXECEEDED: 'return delivery creation window days exceeded',
  ERR_MATERIAL_CODE_IS_REQUIRED: 'material code is required',
  ERR_EPOD_ALREADY_SUBMITTED: 'epod and release time already submitted',
  ERR_INVALID_LR_FILE_EXTENSION: 'lr attachment file extension not supported',
  ERR_SOURCE_DESTINATION_DETAILS_REQUIRED: 'source destination details required',
  ERR_INDENT_ALREADY_DELIVERED: 'indent already in delivered status',
  ERR_NO_MATERIALS_TO_RETURN: 'no materials to return',
  ERR_INVALID_MOVEMENT: 'indent should be either primary or secondary movement',
  ERR_INVALID_SOURCE_REF_ID: 'invalid source reference id',
  ERR_INVALID_DESTINATION_REF_ID: 'invalid destination reference id',
  ERR_RETURN_DELIVERY_NOT_ALLWD: 'return delivery creation not allowed',
  ERR_REPORTED_MORE_THAN_UNLOADING_START: 'Reported At cannot be after Unloading Start At',
  ERR_UNLOADING_START_MORE_THAN_UNLOADING_END: 'Unloading Start At cannot be after Unloading End At',
  ERR_UNLOADING_END_MORE_THAN_RELEASE_AT: 'Unloading End At cannot be after Release At',
  ERR_REPORTED_LESS_THAN_DISPATCH_TIME: 'Reported At cannot be before dispatch time',
  ERR_NO_RETURN_IN_DISPATCHED: 'return delivery creation not allowed in dispatched status',

  ERR_SHIPMENT_NUMBER_NOT_ALLOWED_TO_BE_EMPTY: 'Shipment Number is not allowed to be empty',
  ERR_DATA_DOES_NOT_MATCH_PAYLOAD_STRUCTURE: 'Data does not match Payload 1 or Payload 2 structure',
  ERR_RETURN_TYPE_REQUIRED_WHEN_RETURN_FLAG_TRUE: 'Return type must be provided when return flag is true',
  ERR_UNLOADING_START_REQUIRED_WITH_REPORTED: 'unloading_start_at is required when only reported_at is present.',
  ERR_REPORTED_REQUIRED_WITH_UNLOADING_START: 'reported_at is required when only unloading_start_at is present.',
  ERR_MULTIPLE_FIELDS_REQUIRED_FOR_UNLOADING_END: 'reported_at, unloading_start_at, and release_at are required when only unloading_end_at is present.',
  ERR_MULTIPLE_FIELDS_REQUIRED_FOR_RELEASE: 'reported_at, unloading_start_at, and unloading_end_at are required when only release_at is present.',
  ERR_MULTIPLE_FIELDS_REQUIRED_FOR_RELEASE_UNLOADING: 'reported_at and unloading_start_at are required when only release_at and unloading_end_at are present.',
  ERR_FILE_LINK_REQUIRED_FOR_FILE_NAME: 'File Link is required when File Name is present',
  ERR_FILE_NAME_REQUIRED_FOR_FILE_LINK: 'File Name is required when File Link is present',
};

const validLrFileExtensions = ['jpeg', 'jpg', 'pdf', 'png'];

const returnDeliveryStatus = {
  PENDING: 'PENDING',
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED',
};

module.exports = {
  returnManagementErrorMessage,
  validLrFileExtensions,
  returnDeliveryStatus,
};
